import React, { useMemo } from 'react';

import { useAppliedStockAssets } from '../hooks';









export default function withStockAssets(WrappedComponent) {
  return function WithStockAssets({
    getStockAssetRecords,
    appliedExtras,
    requestedExtras,
    organisationId,
    videoOutputs,
    ...props
  }) {
    const outputIds = useMemo(() =>
    videoOutputs ?
    videoOutputs.map(({ outputId }) => outputId) :
    [],
    [videoOutputs]);

    const { appliedStockAssets, loading } = useAppliedStockAssets(
      {
        appliedExtras,
        requestedExtras
      },
      outputIds,
      organisationId,
      getStockAssetRecords
    );

    const filteredStockAssets = useMemo(() =>
    appliedStockAssets.filter(
      ({ alreadyLicensed }) => !alreadyLicensed
    ),
    [appliedStockAssets]);

    return (
      <WrappedComponent
        appliedStockAssets={filteredStockAssets}
        loadingStockAssets={loading}
        videoOutputs={videoOutputs}
        organisationId={organisationId}
        {...props} />);


  };
}